import React, { FC } from 'react'

import InputItem from '../../../components/InputItem'
import { ITabBaseProps } from './types'

export const Impacts: FC<ITabBaseProps> = ({ isCustomEF, formik }) => {
  return (
    <div className="mb-5 mt-5">
      <p>Please provide environmental impacts for 1 kg of the functional unit specified</p>
      <div className="piece-content-inputs mb-5">
        <InputItem
          disabled={isCustomEF.current}
          name="Land Use"
          description="Please provide Land use in m2*year."
          type="input"
          addonTitle="m2*y"
          onChange={formik.handleChange}
          formikName="landUse"
          showAsterisk
          formik={formik}
          defaultValue={formik.values.landUse === 0 ? '0' : formik.values.landUse}
        />
        <InputItem
          disabled={isCustomEF.current}
          name="Eutrophication"
          description="Please provide eutrophication in g PO43- eq"
          type="input"
          addonTitle="g"
          onChange={formik.handleChange}
          formikName="eutrophication"
          formik={formik}
          showAsterisk
          defaultValue={formik.values.eutrophication === 0 ? '0' : formik.values.eutrophication}
        />
        <InputItem
          disabled={isCustomEF.current}
          name="Biodiversity. sp.yr*10^14"
          description="Please provide the Biodiversity impact in sp.yr*10^14."
          type="input"
          addonTitle="sp.yr*10^14"
          onChange={formik.handleChange}
          formikName="biodiversity"
          formik={formik}
          defaultValue={formik.values.biodiversity === 0 ? null : formik.values.biodiversity}
        />
        {(formik.values.dataOrigin == 1 || formik.values.dataOrigin == 2) &&
          formik.values.farmDataCalculator == 0 && (
            <InputItem
              disabled={isCustomEF.current}
              name="Biodiversity (PDF*year)"
              description={
                'Please provide the Biodiversity impact in "Potentially Disappeared Fraction" (PDF) *year'
              }
              type="input"
              addonTitle="PDF*year"
              onChange={formik.handleChange}
              formikName="biodiversityPDFYear"
              formik={formik}
              defaultValue={
                formik.values.biodiversityPDFYear === 0 ? '0' : formik.values.biodiversityPDFYear
              }
            />
          )}
        <InputItem
          disabled={isCustomEF.current}
          name="Freshwater Withdrawal"
          description="Please provide water usage in L"
          type="input"
          addonTitle="L"
          onChange={formik.handleChange}
          formikName="waterUsage"
          formik={formik}
          showAsterisk
          defaultValue={formik.values.waterUsage === 0 ? '0' : formik.values.waterUsage}
        />
        <InputItem
          disabled={isCustomEF.current}
          name="Freshwater accounting for Water Scarcity"
          description="Please provide water usage including water scarcity conversion in L eq."
          type="input"
          addonTitle="L eq"
          onChange={formik.handleChange}
          formikName="waterUsageIncludingWasterScarcity"
          formik={formik}
          showAsterisk
          defaultValue={
            formik.values.waterUsageIncludingWasterScarcity === 0
              ? '0'
              : formik.values.waterUsageIncludingWasterScarcity
          }
        />
      </div>
      <div className="piece-content-inputs mb-5">
        <InputItem
          name="Abiotic depletion"
          description="Unit of Measure: kg Sb eq"
          type="input"
          addonTitle="kg Sb eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.abioticDepletion', val === '' ? null : val)
          }}
          formikName="impacts.abioticDepletion"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.abioticDepletion === 0
              ? '0'
              : formik.values.impacts.abioticDepletion
          }
        />
        <InputItem
          name="Abiotic depletion (fossil fuels)"
          description="Unit of Measure: MJ"
          type="input"
          addonTitle="MJ"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.abioticDepletionFossilFuels', val === '' ? null : val)
          }}
          formikName="impacts.abioticDepletionFossilFuels"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.abioticDepletionFossilFuels === 0
              ? '0'
              : formik.values.impacts.abioticDepletionFossilFuels
          }
        />
        <InputItem
          name="Acidification"
          description="Unit of Measure: mol H+ eq"
          type="input"
          addonTitle="mol H+ eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.acidification', val === '' ? null : val)
          }}
          formikName="impacts.acidification"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.acidification === 0 ? '0' : formik.values.impacts.acidification
          }
        />
        <InputItem
          name="Ecotoxicity freshwater"
          description="Unit of Measure: CTUe"
          type="input"
          addonTitle="CTUe"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.ecotoxicityFreshwater', val === '' ? null : val)
          }}
          formikName="impacts.ecotoxicityFreshwater"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.ecotoxicityFreshwater === 0
              ? '0'
              : formik.values.impacts.ecotoxicityFreshwater
          }
        />
        <InputItem
          name="Eutrophication terrestrial"
          description="Unit of Measure: mol N eq"
          type="input"
          addonTitle="mol N eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.eutrophicationTerrestrial', val === '' ? null : val)
          }}
          formikName="impacts.eutrophicationTerrestrial"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.eutrophicationTerrestrial === 0
              ? '0'
              : formik.values.impacts.eutrophicationTerrestrial
          }
        />
        <InputItem
          name="Freshwater ecotoxicity"
          description="Unit of Measure: kg 1,4-DCB"
          type="input"
          addonTitle="kg 1,4-DCB"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.freshwaterEcotoxicity', val === '' ? null : val)
          }}
          formikName="impacts.freshwaterEcotoxicity"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.freshwaterEcotoxicity === 0
              ? '0'
              : formik.values.impacts.freshwaterEcotoxicity
          }
        />
        <InputItem
          name="Freshwater eutrophication"
          description="Unit of Measure: kg P eq"
          type="input"
          addonTitle="kg P eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.freshwaterEutrophication', val === '' ? null : val)
          }}
          formikName="impacts.freshwaterEutrophication"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.freshwaterEutrophication === 0
              ? '0'
              : formik.values.impacts.freshwaterEutrophication
          }
        />
        <InputItem
          name="Human carcinogenic toxicity"
          description="Unit of Measure: kg 1,4-DCB"
          type="input"
          addonTitle="kg 1,4-DCB"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.humanCarcinogenicToxicity', val === '' ? null : val)
          }}
          formikName="impacts.humanCarcinogenicToxicity"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.humanCarcinogenicToxicity === 0
              ? '0'
              : formik.values.impacts.humanCarcinogenicToxicity
          }
        />
        <InputItem
          name="Human non-carcinogenic toxicity"
          description="Unit of Measure: kg 1,4-DCB"
          type="input"
          addonTitle="kg 1,4-DCB"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.humanNonCarcinogenicToxicity', val === '' ? null : val)
          }}
          formikName="impacts.humanNonCarcinogenicToxicity"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.humanNonCarcinogenicToxicity === 0
              ? '0'
              : formik.values.impacts.humanNonCarcinogenicToxicity
          }
        />
        <InputItem
          name="Human toxicity cancer"
          description="Unit of Measure: CTUh"
          type="input"
          addonTitle="CTUh"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.humanToxicityCancer', val === '' ? null : val)
          }}
          formikName="impacts.humanToxicityCancer"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.humanToxicityCancer === 0
              ? '0'
              : formik.values.impacts.humanToxicityCancer
          }
        />
        <InputItem
          name="Human toxicity non-cancer"
          description="Unit of Measure: CTUh"
          type="input"
          addonTitle="CTUh"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.humanToxicityNonCancer', val === '' ? null : val)
          }}
          formikName="impacts.humanToxicityNonCancer"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.humanToxicityNonCancer === 0
              ? '0'
              : formik.values.impacts.humanToxicityNonCancer
          }
        />
        <InputItem
          name="Ionising radiation (human health)"
          description="Unit of Measure: kBq U235 eq"
          type="input"
          addonTitle="kBq U235 eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.ionisingRadiation', val === '' ? null : val)
          }}
          formikName="impacts.ionisingRadiation"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.ionisingRadiation === 0
              ? '0'
              : formik.values.impacts.ionisingRadiation
          }
        />
        <InputItem
          name="Marine ecotoxicity"
          description="Unit of Measure: kg 1,4-DCB"
          type="input"
          addonTitle="kg 1,4-DCB"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.marineEcotoxicity', val === '' ? null : val)
          }}
          formikName="impacts.marineEcotoxicity"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.marineEcotoxicity === 0
              ? '0'
              : formik.values.impacts.marineEcotoxicity
          }
        />
        <InputItem
          name="Marine eutrophication"
          description="Unit of Measure: kg N eq"
          type="input"
          addonTitle="kg N eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.marineEutrophication', val === '' ? null : val)
          }}
          formikName="impacts.marineEutrophication"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.marineEutrophication === 0
              ? '0'
              : formik.values.impacts.marineEutrophication
          }
        />
        <InputItem
          name="Particulate matter"
          description="Unit of Measure: disease incidence"
          type="input"
          addonTitle="disease incidence"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.particulateMatter', val === '' ? null : val)
          }}
          formikName="impacts.particulateMatter"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.particulateMatter === 0
              ? '0'
              : formik.values.impacts.particulateMatter
          }
        />
        <InputItem
          name="Photochemical ozone formation (human health)"
          description="Unit of Measure: kg NMVOC eq"
          type="input"
          addonTitle="kg NMVOC eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.photochemicalOzoneFormation', val === '' ? null : val)
          }}
          formikName="impacts.photochemicalOzoneFormation"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.photochemicalOzoneFormation === 0
              ? '0'
              : formik.values.impacts.photochemicalOzoneFormation
          }
        />
        <InputItem
          name="Stratospheric ozone depletion"
          description="Unit of Measure: kg CFC11 eq"
          type="input"
          addonTitle="kg CFC11 eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.stratosphericOzoneDepletion', val === '' ? null : val)
          }}
          formikName="impacts.stratosphericOzoneDepletion"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.stratosphericOzoneDepletion === 0
              ? '0'
              : formik.values.impacts.stratosphericOzoneDepletion
          }
        />
        <InputItem
          name="Terrestrial ecotoxicity"
          description="Unit of Measure: kg 1,4-DCB"
          type="input"
          addonTitle="kg 1,4-DCB"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.terrestrialEcotoxicity', val === '' ? null : val)
          }}
          formikName="impacts.terrestrialEcotoxicity"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.terrestrialEcotoxicity === 0
              ? '0'
              : formik.values.impacts.terrestrialEcotoxicity
          }
        />
      </div>
      <div className="piece-content-inputs mb-5">
        <InputItem
          name="Damage to terrestrial ecosystems, land occupation"
          description="Unit of Measure: PDF*year"
          type="input"
          addonTitle="PDF*year"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.damageToTerrestrialEcosystems_LandOccupation',
              val === '' ? null : val
            )
          }}
          formikName="impacts.damageToTerrestrialEcosystems_LandOccupation"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.damageToTerrestrialEcosystems_LandOccupation === 0
              ? '0'
              : formik.values.impacts.damageToTerrestrialEcosystems_LandOccupation
          }
        />
        <InputItem
          name="Damage to terrestrial ecosystems, land transformation"
          description="Unit of Measure: PDF*year"
          type="input"
          addonTitle="PDF*year"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.damageToTerrestrialEcosystems_LandTransformation',
              val === '' ? null : val
            )
          }}
          formikName="impacts.damageToTerrestrialEcosystems_LandTransformation"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.damageToTerrestrialEcosystems_LandTransformation === 0
              ? '0'
              : formik.values.impacts.damageToTerrestrialEcosystems_LandTransformation
          }
        />
        <InputItem
          name="Soil quality index, total land use effects"
          description="Unit of Measure: points"
          type="input"
          addonTitle="points"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.soilQualityIndex_TotalLandUseEffects',
              val === '' ? null : val
            )
          }}
          formikName="impacts.soilQualityIndex_TotalLandUseEffects"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.soilQualityIndex_TotalLandUseEffects === 0
              ? '0'
              : formik.values.impacts.soilQualityIndex_TotalLandUseEffects
          }
        />
        <InputItem
          name="Cumulative Energy Demand"
          description="Unit of Measure: MJ"
          type="input"
          addonTitle="MJ"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.cumulativeEnergyDemand', val === '' ? null : val)
          }}
          formikName="impacts.cumulativeEnergyDemand"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.cumulativeEnergyDemand === 0
              ? '0'
              : formik.values.impacts.cumulativeEnergyDemand
          }
        />
        <InputItem
          name="Cumulative Energy Demand - non-renewable"
          description="Unit of Measure: MJ"
          type="input"
          addonTitle="MJ"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.cumulativeEnergyDemand_NonRenewable',
              val === '' ? null : val
            )
          }}
          formikName="impacts.cumulativeEnergyDemand_NonRenewable"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.cumulativeEnergyDemand_NonRenewable === 0
              ? '0'
              : formik.values.impacts.cumulativeEnergyDemand_NonRenewable
          }
        />
        <InputItem
          name="Cumulative Energy Demand - renewable"
          description="Unit of Measure: MJ"
          type="input"
          addonTitle="MJ"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.cumulativeEnergyDemand_Renewable',
              val === '' ? null : val
            )
          }}
          formikName="impacts.cumulativeEnergyDemand_Renewable"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.cumulativeEnergyDemand_Renewable === 0
              ? '0'
              : formik.values.impacts.cumulativeEnergyDemand_Renewable
          }
        />
        <InputItem
          name="Abiotic resource depletion, fossil fuels"
          description="Unit of Measure: MJ"
          type="input"
          addonTitle="MJ"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.abioticResourceDepletionFossilFuels',
              val === '' ? null : val
            )
          }}
          formikName="impacts.abioticResourceDepletionFossilFuels"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.abioticResourceDepletionFossilFuels === 0
              ? '0'
              : formik.values.impacts.abioticResourceDepletionFossilFuels
          }
        />
        <InputItem
          name="Minerals & metals use"
          description="Unit of Measure: kg"
          type="input"
          addonTitle="kg"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.mineralsMetalsUse', val === '' ? null : val)
          }}
          formikName="impacts.mineralsMetalsUse"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.mineralsMetalsUse === 0
              ? '0'
              : formik.values.impacts.mineralsMetalsUse
          }
        />
      </div>
      <InputItem
        disabled={isCustomEF.current}
        name="Comment"
        description="Please provide any additional information you have on this entry."
        type="text"
        onChange={formik.handleChange}
        formik={formik}
        className={'w-full'}
        defaultValue={formik.values.comment || ''}
        formikName="comment"
      />
    </div>
  )
}

export default Impacts
